import { restoreActiveToast } from '../../../shared/utils/notifications';

export const MobileNotificationView = Backbone.Marionette.Layout.extend({
    template: '#tpl_notification',

    TOP_START: '-100px', // what 'top' should we animate FROM?
    TOP_TARGET: null, // what 'top' should we animate TO?

    parent_page: null, // BaseToolbarNavPageLayout - IF AVAILABLE (not for global notif), the view this was created from
    _default_classnames: null, // the default class names for our .toast_notification element.
    // We use this to reset after changing them.

    events: {
        click: 'hide_notification'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        // Determine what our default class names are so we can revert them later
        if (!this._default_classnames) {
            this._default_classnames = this.$el.attr('class');
        }
    },

    onRender: function () {
        this._calculate_top_target();
        this._restore_notification();
    },

    on_show: function () {
        this._isShown = true; // we need to set this manually we're not created through Marionette's region.show()

        this._calculate_top_target();
        this._restore_notification();
    },

    /**
     * Calculate TOP_TARGET, the 'top' value we will want to animate too
     */
    _calculate_top_target: function () {
        if (this.TOP_TARGET) {
            return;
        }
        if (!this._isShown) {
            return;
        }

        var $content = this.$el.parents('.main_content:not(.stale), #content_overlay');

        if ($content.find('.toolbarnav').length) {
            this.TOP_TARGET = $content.find('.toolbarnav').offset().top + $content.find('.toolbarnav').outerHeight();
        } else {
            if ($('html').hasClass('fullscreen')) {
                this.TOP_TARGET = `${$('.fullscreen_filler').height() + 43}px`;
            } else {
                this.TOP_TARGET = '43px';
            }
        }
    },

    /**
     * Restore any previous notification that may have been shown in another view or before re-rendering.
     */
    _restore_notification: function () {
        if (!this._isShown) {
            return;
        }
        if (!this.parent_page || this.parent_page.is_modal) {
            return;
        }

        restoreActiveToast();
    },

    /**
     * Show a toast notification that satisfies a variety of options.
     *
     * @param  {object}     options                 Options for showing the notification
     * @param  {string}     options.msg             The message that should appear
     * @param  {string}     options.html_class      The HTML class that should be given to this notification
     * @param  {string}     options.icon            The class for the icon (if any) to be shown in the notificaiton (usually 'df-*')
     * @param  {string}     options.show_method     What method should we use to show the notification? Options are 'normal' (default), 'replace', or 'restore'
     */
    show_notification: function (options) {
        options = options || {};
        options.show_method || (options.show_method = 'normal');
        var this_ = this;

        this._reset_notification_classes(true);
        this.$el.css({
            top: options.show_method != 'normal' ? this.TOP_TARGET : this.TOP_START, // if options.replace, don't animate - we'll just show it where it should end up
            display: 'block'
        });

        var _apply_msg_and_icon = function () {
            this_.$el.find('.msg').html(options.msg);
            this_.$el.find('.msg_icon').attr('class', 'msg_icon'); // remove whatever previous icon class this had
            if (options.icon) {
                this_.$el.find('.msg_icon').addClass(options.icon).show();
            } else {
                this_.$el.find('.msg_icon').hide();
            }
        };

        if (options.show_method == 'replace') {
            // if we're simply updating a current notification, fade text out/in after/before changing
            this.$el.find('.toast_body').velocity(
                { opacity: 0 },
                {
                    duration: 300,
                    complete: function () {
                        _apply_msg_and_icon();
                        this_.$el.find('.toast_body').velocity({ opacity: 1 }, { duration: 300 });
                    }
                }
            );
        } else {
            _apply_msg_and_icon();
        }

        this._reset_notification_classes(false);
        this.$el.addClass(options.html_class);

        if (options.show_method != 'normal') {
            return;
        } // don't slide down if already being shown

        // Animate!
        this.$el.velocity(
            { top: this.TOP_TARGET },
            {
                duration: 500,
                easing: 'easeOutQuint'
            }
        );
    },

    /**
     * Hide our notification.
     */
    hide_notification: function () {
        var this_ = this;

        // Tell notifications.ts it can destroy its timers, etc.
        $f.application.vent.trigger('notification:hiding');

        // To be sure we don't leave any rogue notifications open let's remove the others, too.
        // (e.g., if we navigated to a modal while the notifcation was open on web, we don't want
        // to just close the current one)
        $('.toast_notification').not(this.$el).hide();

        this.$el.velocity('stop');
        this.$el.velocity(
            { top: this.TOP_START },
            {
                duration: 300,
                complete: function () {
                    this_._reset_notification_classes(true);
                }
            }
        );

        return false;
    },

    /**
     * Reset the notification element's classes to default.
     * @see this._default_classnames
     */
    _reset_notification_classes: function (remove_styling) {
        if (remove_styling) {
            this.$el.attr('style', '');
        }
        this.$el.attr('class', this._default_classnames);
    }
});
